<template>
  <v-application v-if="access.item_add_from_warehause">
    <v-card class="ma-2">
      <v-card-title>
        <v-autocomplete
          v-model="search_item"
          :label="$t('search')"
          :append-icon="''"
          :no-data-text="$t('no_item_found')"
          v-on:update:search-input="searchItems"
          :items="items_list"
          return-object
          item-text="search_text"
          v-on:change="selectAction"
        >
          <template #[`item.item-name`]="{}"></template>
          <template #item="data">
            <template>
              <v-list-item-content>
                <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                <v-list-item-subtitle>{{
                  data.item.barcode
                }}</v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </template>
        </v-autocomplete>
        <v-btn text color="primary" @click="openDialog">{{
          $t("add_new")
        }}</v-btn>
      </v-card-title>
      <v-form v-model="is_valid_table_items">
        <v-data-table
          hide-default-footer
          disable-sort
          :headers="headers"
          :items="items"
          :items-per-page="1000"
        >
          <template #[`item.name`]="{ item }">
            <v-text-field
              v-model="item.name"
              autocomplete="off"
              :rules="[fieldRules.required]"
              :ref="'name' + item.barcode"
            />
          </template>
          <template #[`item.sold_by`]="{ item }">
            {{ $t(item.sold_by) }}
          </template>
          <template #[`item.remove`]="{ item }">
            <v-btn icon @click="removeItem(item)"
              ><v-icon>mdi-delete</v-icon></v-btn
            >
          </template>
        </v-data-table>
      </v-form>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="primary"
          :disabled="items.length == 0 || !is_valid_table_items"
          @click="createItems"
          >{{ $t("create_items") }}</v-btn
        >
      </v-card-actions>
    </v-card>

    <v-dialog v-model="create_item_dialog" persistent width="500">
      <v-card>
        <v-card-title>{{ $t("create_item") }}</v-card-title>
        <v-card-text>
          <p v-if="allready_exist" class="red--text">
            {{ $t("item_allready_exist") }}
          </p>
          <p v-else-if="error" class="red--text">{{ $t("error_on_saving") }}</p>
          <v-form v-model="is_valid">
            <v-text-field
              v-model="newItem.name"
              :label="$t('name')"
              autocomplete="off"
              :rules="[fieldRules.required]"
              ref="name"
            />
            <v-text-field
              v-model="newItem.barcode"
              type="number"
              :label="$t('barcode')"
              :rules="[fieldRules.acceptBarcode]"
              autocomplete="off"
              ref="barcode"
            />
            <v-select
              v-model="newItem.sold_by"
              :label="$t('sold_by')"
              autocomplete="off"
              :items="sold_by_options"
              :rules="[fieldRules.require]"
              ref="sold_by"
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="itemCreateCancel">{{ $t("cancel") }}</v-btn>
          <v-btn
            text
            @click="itemCreateSave"
            color="primary"
            :disabled="!is_valid"
            >{{ $t("save") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="confirm_dialog" persistent width="500">
      <v-card>
        <v-card-title>
          {{ $t("creating_item") + `: ${createItemToConfirm.create}` }}
        </v-card-title>
        <v-card-title>
          {{ $t("updating_item") + `: ${createItemToConfirm.update}` }}
        </v-card-title>
        <v-card-actions>
          <v-spacer />
          <v-btn v-if="!confirm_loading" text @click="confirm_dialog = false">{{
            $t("cancel")
          }}</v-btn>
          <v-btn
            :loading="confirm_loading"
            text
            color="primary"
            @click="confirmItemCreate"
            >{{ $t("confirm") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-application>
  <error404 v-else></error404>
</template>

<script>
export default {
  name: "items_from_global",
  data: () => ({
    search_item: "",
    create_item_dialog: false,
    is_valid: false,
    is_valid_table_items: false,
    allready_exist: false,
    error: false,
    newItem: {
      name: null,
      barcode: null,
      sold_by: null,
    },
    items: [],
    search_text: "123",
    items_list: [],
    allItemsMap: {},
    createItemToConfirm: {
      create: 0,
      update: 0,
    },
    confirm_dialog: false,
    confirm_loading: false,
  }),
  computed: {
    headers() {
      return [
        { text: this.$t("name"), value: "name" },
        { text: this.$t("barcode"), value: "barcode", align: "right" },
        {
          text: this.$t("sold_by"),
          value: "sold_by",
          align: "center",
          width: 100,
        },
        { text: null, value: "remove", align: "center", width: 50 },
      ];
    },
    form() {
      return {
        name: this.newItem.name,
        barcode: this.newItem.barcode,
        sold_by: this.newItem.sold_by,
      };
    },
  },
  methods: {
    openDialog() {
      this.create_item_dialog = true;
    },
    itemCreateCancel() {
      this.create_item_dialog = false;
      this.newItem = {
        name: null,
        barcode: null,
        sold_by: null,
      };
      Object.keys(this.form).forEach((f) => {
        this.$refs[f].reset();
      });
      this.allready_exist = false;
    },
    async itemCreateSave() {
      const result = await this.$communicator("product_create", {
        params: this.newItem,
      });

      if (result && result.data && result.data.statusCode == 200) {
        this.$toast.success("Success", { timeout: 2000 });
        this.items.push(this.newItem);
        this.itemCreateCancel();
      } else if (result && result.data && result.data.statusCode == 411) {
        this.$toast.error(
          `Item allready exist barcode:${result.data?.data?.barcode}`,
          {
            timeout: 2000,
          }
        );
        this.allready_exist = true;
        this.error = false;
      } else {
        this.allready_exist = false;
        this.error = true;
      }
    },
    async searchItems(search_text) {
      if (!search_text) {
        search_text = "";
      }
      if (search_text == this.search_text) {
        return;
      }
      this.search_text = search_text;
      const result = this.$communicator.then(
        this,
        await this.$communicator("product_search", {
          params: {
            search: search_text,
          },
        })
      );
      if (result instanceof Array) {
        for (const index in result) {
          result[index].search_text =
            result[index].name + result[index].barcode;
        }
        this.items_list = result;
      }
    },
    selectAction() {
      if (this.search_item && this.search_item.barcode) {
        if (!this.allItemsMap[this.search_item.barcode]) {
          this.items.push(this.search_item);
          this.allItemsMap[this.search_item.barcode] = true;
        }
      }
      this.search_item = {
        name: "",
        barcode: null,
      };
    },
    removeItem(item) {
      if (item && item.barcode) {
        const items = [];
        for (const itm of this.items) {
          if (itm.barcode != item.barcode) {
            items.push(itm);
          }
        }
        this.items = items;
        this.allItemsMap[item.barcode] = false;
      }
    },
    async createItems() {
      const result = this.$communicator.then(
        this,
        await this.$communicator("create_items_from_product", {
          params: {
            check: true,
            items: this.items,
          },
        })
      );
      if (result) {
        this.$toast.success("Success", { timeout: 2000 });
        this.createItemToConfirm = {
          create: result.creating,
          update: result.updating,
        };
      } else {
        this.createItemToConfirm = {
          create: 0,
          update: 0,
        };
      }
      this.confirm_dialog = true;
    },
    async confirmItemCreate() {
      this.confirm_loading = true;
      const result = this.$communicator.then(
        this,
        await this.$communicator("create_items_from_product", {
          params: {
            check: false,
            items: this.items,
          },
        })
      );
      if (result) {
        this.$toast.success("Success", { timeout: 2000 });
        this.$router.push("/items/list").catch(() => {});
      } else {
        this.confirm_loading = false;
      }
    },
  },
  beforeMount() {
    this.access = this.$store.state.access;
  },
};
</script>
